import React from 'react';
import { Img, Icon, Button } from 'components';
import { Section, Box, Text } from 'styles';

export function Section3({ setRef }) {
  return (
    <Section ref={setRef} $backgroundColor="secondary10" $scrollMarginTop={91} $mScrollMarginTop={107}>
      <Box $maxWidth={1600} $padding="80px 40px" $mPadding="40px 20px" $margin="auto">
        <Box $width="fit-content" $margin="auto">
          <Button $type="badge">
            <Icon name="badgeIcon" />
            Process
          </Button>
        </Box>
        <Text $type="b40" $mType="b28" $padding="24px 0 16px" $textAlign="center">
          N-Survey 진행 방법
        </Text>
        <Text $type="18" $mType="16" $textAlign="center" $color="gray600">
          의뢰부터 결과 리포트 제공까지 전 과정을 지원합니다.
        </Text>
        <Box $margin="auto" $width="fit-content" $padding="64px 40px 80px" $mPadding="24px 0" $maxWidth={1600}>
          <Img desktopSrc="main3" mobileSrc="moMain3" $width="100%" />
        </Box>

      </Box>
    </Section>
  );
}